"use client";

import { Accordion, Typography } from "@drpcrd/shared/ui";
import { FadeInSection } from "../fade-in-section";
import { SectionEyebrow } from "../section-eyebrow";
import { TestimonialQuote } from "../testimonial-quote";
import { CAMPAIGN_DELIVERY_STEPS } from "./campaign-delivery-items";
import { CampaignDeliveryAccordionItem } from "./campaign-delivery-accordion-item";
import threeLogo from "./assets/three-logo.png";

/**
 * Workflow section: the numbered campaign workflow accordion showing how
 * Nutcake takes the admin out of getting deals done.
 */
export const CampaignDelivery = () => (
  <section id="workflow" className="scroll-mt-12 px-3 sm:px-6 md:px-8">
    <div className="mx-auto max-w-5xl space-y-6">
      <FadeInSection className="space-y-3">
        <SectionEyebrow>Workflow</SectionEyebrow>
        <Typography
          as="h2"
          weight="semibold"
          className="font-poppins text-4xl leading-[1.05] tracking-[-0.04em] text-pink-500 sm:text-5xl lg:text-7xl"
        >
          Your team at their most{" "}
          <span className="text-pink-700">organised and productive</span>
        </Typography>
        <Typography
          size="sm"
          color="black"
          className="leading-2.75 sm:text-lg sm:leading-3"
        >
          Nutcake takes the grind out of getting the deal done. Outreach goes
          out automatically to hundreds of creators, contracts are generated and
          signed without manual chasing, and payment releases the moment work’s
          approved - freeing your team to focus on strategy, not admin.
        </Typography>
      </FadeInSection>

      <FadeInSection>
        <Accordion
          type="single"
          defaultValue={CAMPAIGN_DELIVERY_STEPS[0].number}
        >
          {CAMPAIGN_DELIVERY_STEPS.map((step) => (
            <CampaignDeliveryAccordionItem key={step.number} step={step} />
          ))}
        </Accordion>
      </FadeInSection>

      {/* Testimonial */}
      <FadeInSection>
        <TestimonialQuote
          quote="Nutcake found a creator to hit an emerging trend. The content was live in under 24 hours. Super fast!"
          bubbleClassName="bg-pink-50 text-pink-600"
          avatarSrc={threeLogo.src}
          name="David Best"
          subtitle="Head of Video · Three UK"
        />
      </FadeInSection>
    </div>
  </section>
);
